import {createSinglePathSVG} from './TEMPLATE'

export const LayoutGrid_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M10 13a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h6Zm10 0a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h6Zm-5 6h4v-4h-4v4ZM5 19h4v-4H5v4Zm5-16a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h6Zm10 0a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h6Zm-5 6h4V5h-4v4ZM5 9h4V5H5v4Z',
})
